(function(){
"use strict";
/* Allinea il voto: la media reale e' 4,5 */
var n=document.querySelector(".dema-buy .stars .n");
if(n&&n.textContent.trim()!=="4,5")n.textContent="4,5";

var b=document.getElementById("demaStars");
if(!b)return;
b.addEventListener("click",function(e){
 e.preventDefault();
 var track=document.getElementById("rvTrack");
 var target=track?(track.closest(".band")||track):null;
 if(!target)return;
 target.scrollIntoView({behavior:"smooth",block:"start"});
 if(track){
  setTimeout(function(){
   var i=0;
   var step=function(){
    if(i>=2)return;
    track.scrollBy({left:track.clientWidth*.55,behavior:"smooth"});
    i++;setTimeout(step,700);
   };
   step();
   setTimeout(function(){track.scrollTo({left:0,behavior:"smooth"})},2100);
  },850);
 }
});
})();
